// import { toast } from 'sonner';
// import { createClient } from '@supabase/supabase-js';

// // Initialize Supabase client
// const supabase = createClient(
//   process.env.REACT_APP_SUPABASE_URL,
//   process.env.REACT_APP_SUPABASE_ANON_KEY
// );

// export const subscribeToNewsletter = async (email, userId) => {
//   // Validation
//   if (!userId) {
//     toast.error('Please log in to subscribe', {
//       description: 'You need to be logged in to subscribe to our newsletter.',
//     });
//     return { success: false };
//   }

//   if (!email) {
//     toast.error('Please enter your email address');
//     return { success: false };
//   }

//   // Basic email validation
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   if (!emailRegex.test(email)) {
//     toast.error('Please enter a valid email address');
//     return { success: false };
//   }

//   try {
//     // Get the current session token
//     const { data: { session } } = await supabase.auth.getSession();
    
//     if (!session) {
//       toast.error('Please log in to subscribe');
//       return { success: false };
//     }

//     const response = await fetch('/api/newsletter-subscribe', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${session.access_token}` // Send the auth token
//       },
//       body: JSON.stringify({ 
//         email,
//         userId
//       }),
//     });

//     // Get response as text first
//     const responseText = await response.text();
    
//     let data;
//     try {
//       data = JSON.parse(responseText);
//     } catch (parseError) {
//       throw new Error(responseText || 'Subscription failed');
//     }

//     if (!response.ok) {
//       // Handle specific error messages
//       if (data.error === 'This email is already subscribed') {
//         toast.info('You are already subscribed!', {
//           description: 'Thanks for your continued interest in JmoLux.',
//         });
//       } else {
//         throw new Error(data.error || 'Subscription failed');
//       }
//       return { success: false };
//     }

//     // Success message
//     toast.success('Thank you for subscribing!', {
//       description: 'You\'ll receive exclusive offers and updates in your inbox.',
//       duration: 5000,
//     });

//     return { success: true };

//   } catch (error) {
//     console.error('Newsletter subscription error:', error);
//     toast.error('Subscription failed', {
//       description: error.message || 'Please try again later or contact support.',
//     });
//     return { success: false, error: error.message };
//   }
// };



import { toast } from 'sonner';
import { supabase } from '../lib/supabase';

export const subscribeToNewsletter = async (email, userId, userEmail) => {
  if (!email) {
    toast.error('Please enter your email address');
    return { success: false };
  }

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    toast.error('Please enter a valid email address');
    return { success: false };
  }

  // Logged-in users should subscribe with the email tied to the account.
  if (
    userId &&
    userEmail &&
    email.toLowerCase().trim() !== userEmail.toLowerCase().trim()
  ) {
    toast.error('Email mismatch', {
      description: 'You can only subscribe with your account email address.',
    });
    return { success: false };
  }

  try {
    const { data: { session } } = await supabase.auth.getSession();
    const headers = {
      'Content-Type': 'application/json',
    };

    if (session?.access_token) {
      headers.Authorization = `Bearer ${session.access_token}`;
    }

    const response = await fetch('/api/newsletter-subscribe', {
      method: 'POST',
      headers,
      body: JSON.stringify({ 
        email,
        userId: userId || null,
      }),
    });

    // Get response as text first
    const responseText = await response.text();
    
    let data;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      throw new Error(responseText || 'Subscription failed');
    }

    if (!response.ok) {
      // Handle specific error messages
      if (data.error === 'This email is already subscribed') {
        toast.info('You are already subscribed!', {
          description: 'Thanks for your continued interest in JmoLux.',
        });
        return { success: false, alreadySubscribed: true };
      } else {
        throw new Error(data.error || 'Subscription failed');
      }
    }

    // Success message
    toast.success('Thank you for subscribing!', {
      description: 'You\'ll receive exclusive offers and updates in your inbox.',
      duration: 5000,
    });

    return { success: true };

  } catch (error) {
    console.error('Newsletter subscription error:', error);
    toast.error('Subscription failed', {
      description: error.message || 'Please try again later or contact support.',
    });
    return { success: false, error: error.message };
  }
};


export const checkSubscriptionStatus = async (userId) => {
  if (!userId) return { isSubscribed: false };

  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) return { isSubscribed: false };

    const response = await fetch(`/api/newsletter-status?userId=${userId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${session.access_token}`
      },
    });

    const data = await response.json();
    
    return { isSubscribed: data.isSubscribed || false };

  } catch (error) {
    console.error('Check subscription status error:', error);
    return { isSubscribed: false };
  }
};
